// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchInput_root__wnXmr","icon":"SearchInput_icon__VB_M7","input":"SearchInput_input__dt360"};